import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { Interlocuzione } from "@/types/api";

export function useConversazioni() {
  return useQuery({
    queryKey: ["conversazioni"],
    queryFn: () => apiFetch<Interlocuzione[]>("/api/v1/conversazioni"),
    staleTime: 30_000,
  });
}
